<accredible-base-footer *transloco="let t; read: 'employment_accredible_com.footer'">
  <div class="content">
    <div class="footer-content">
      <div class="logo">
        <a class="accredible"
          href="https://www.accredible.com/issuing-with-accredible/?utm_source=credential&utm_medium=referral&utm_campaign=footer_logo_updated"
          target="_blank">
          <img src="assets/themes/credential.accredible.com/images/acme_logo_white.png"
            [alt]="t('acme_logo')">
        </a>
      </div>

      <nav class="footer-nav"
        role="navigation"
        [attr.aria-label]="t('aria_accredible_links')">
        <ul>
          <li>
            <a href="https://credential.accredible.com/"
              target="_blank">
              {{ t('all_certifications') }}
            </a>
          </li>
          <li>
            <a href="https://credential.accredible.com/"
              target="_blank">
              {{ t('terms_of_service') }}
            </a>
          </li>
          <li>
            <a href="https://credential.accredible.com/"
              target="_blank">{{ t('privacy_policy') }}</a>
          </li>
          <li>
            <a routerLink="site-map"
              [queryParams]="{ username: username }">
              {{ t('site_map') }}
            </a>
          </li>
          <li>
            <div class="language-selector-container">
              <accredible-language-selector [languages]="languages"
                [themeName]="themeName">
              </accredible-language-selector>
            </div>
          </li>
        </ul>
      </nav>
    </div>

    <div class="copyright">
      <span>{{ t('copyright') }}</span> <br>
      <a href="https://www.accredible.com/spotlight/?_ga=2.72935699.1467320304.1623748988-1440708316.1623748988"
        target="_blank">{{ t('powered_by') }}</a>
    </div>
  </div>
</accredible-base-footer>
